<template>
  <Checkbox ref="field" v-bind="fieldProps" v-on="$listeners">
    <FieldValidator
      ref="fieldValidator"
      slot="below"
      :validations="validations"
      :value="value"
      :isRequired="isRequired"
      :hasFocus="hasFocus"
      :showMessageOn="showMessageOn"
      @isValid="onPropChange('isValid', $event)"
      @isMessageVisible="onPropChange('isMessageVisible', $event)"
      @failedValidation="onPropChange('failedValidation', $event)"
    >
      <FieldValidation
        :isValid="isValid"
        :isMessageVisible="isMessageVisible"
        :showIndicator="false"
        :message="message"
        :type="validationType"
      />
    </FieldValidator>
  </Checkbox>
</template>

<script>
import { filter } from '@/helpers/object'
import formFieldInterfaceMixin, {
  VALIDATION_TYPE_VARIANT_MAPPING,
} from '@/components/_shared/Form/form-field-interface-mixin'
import FieldValidator, {
  EVENT_TYPES,
} from '@/components/_shared/Form/Validation/FieldValidator.vue'
import FieldValidation, {
  TYPES as VALIDATION_TYPES,
} from '@/components/_shared/Form/Validation/FieldValidation.vue'
import Checkbox from '@/components/_shared/Form/Checkbox/Checkbox.vue'
import propsCheckbox from '@/components/_shared/Form/Checkbox/props-checkbox'

export default {
  name: 'FormCheckbox',
  components: {
    Checkbox,
    FieldValidator,
    FieldValidation,
  },
  mixins: [formFieldInterfaceMixin],

  props: { ...propsCheckbox },

  data() {
    return {
      hasFocus: false,
      isValid: false,
      isMessageVisible: false,
      failedValidation: null,
    }
  },

  computed: {
    fieldProps() {
      return {
        ...this.$attrs,
        ...filter(this._props, Object.keys(propsCheckbox)),
        variant: this.isMessageVisible
          ? VALIDATION_TYPE_VARIANT_MAPPING[this.validationType]
          : VALIDATION_TYPE_VARIANT_MAPPING['default'],
      }
    },

    message() {
      return this.failedValidation?.message || ''
    },

    validationType() {
      return this.failedValidation?.type || VALIDATION_TYPES.error
    },
  },

  methods: {
    getIsValid() {
      return this.isValid
    },

    getIsMessageVisible() {
      return this.isMessageVisible
    },

    validate() {
      this.$refs.fieldValidator.updateOn(EVENT_TYPES.demand)
    },

    setForceMessage() {
      // not implemented
    },

    onPropChange(name, value) {
      this[name] = value
      this.$emit(name, value)
    },
  },
}
</script>
